import { useState, useCallback } from 'react';
import useAuthUser from '../../auth/hooks/useAuthUser';
import { useNavigate } from 'react-router-dom';
import { processConfigBatch } from '../services/createConfig.api';
import { generateFileName, formatName } from '../utils/createConfig.helpers';

function chunkByCount(arr, size) {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
}

export default function useProcessConfigs({ setToast }) {
  const [processing, setProcessing] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuthUser();

  const processValidated = useCallback(async (rows) => {
    if (!rows?.length) return;
    const fileName = generateFileName();
    setProcessing(true);
    const displayUser = formatName(user?.name) || user?.email || 'Unknown User';

    try {
      // Add user to each row
      const rowsWithUser = rows.map(row => ({ ...row, User: displayUser }));
      const batches = chunkByCount(rowsWithUser, 200);
      const total = batches.length;

      for (let i = 0; i < total; i++) {
        await processConfigBatch({
          fileName,
          batchIndex: i,
          totalBatches: total,
          rows: batches[i],
        });
        setToast({
          open: true,
          message: `Processed batch ${i + 1}/${total}`,
          severity: 'success',
        });
      }

      setToast({ open: true, message: 'Processed successfully.', severity: 'success' });
      navigate('/home/structure-logs', { state: { fileName, status: null } });
      return { ok: true, fileName };
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.message ||
        'Unexpected error.';
      setToast({ open: true, message: msg, severity: 'error' });
      return { ok: false, error: err };
    } finally {
      setProcessing(false);
    }
  }, [navigate, setToast, user]);

  return { processing, processValidated };
}
